import React from 'react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { isCountryAvailable } from 'modules/referral_program/components/helpers'

import Content from './_Content'

const ReferralProgramRevampPage = () => {
  const { company, employee } = useCurrentSession()

  const mainLegalEntity = company.legalEntities.find((e) => e.main)
  const isoCountryCode = mainLegalEntity?.country || employee?.legalEntity?.country

  useUnsafeEffect(() => {
    track(trackingEvents.settings.visitReferralProgramPage)
  }, [])

  if (!isoCountryCode || !isCountryAvailable(isoCountryCode)) {
    return null
  }

  return (
    <ResponsivePage.Body showHeader={false} variant="wide">
      <Content />
    </ResponsivePage.Body>
  )
}

export default ReferralProgramRevampPage
